// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__35K2c","header":"PatientBlock_header__3EnQC","label":"PatientBlock_label__3eaG8","option":"PatientBlock_option__3hIIG"};